import * as React from 'react';

function Logo(props) {
  return (
    <svg
      width={64}
      height={64}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill="#fff" d="M0 0h64v64H0z" />
      <rect
        x={0.97}
        y={0.97}
        width={62.061}
        height={62.061}
        rx={23.273}
        fill="url(#prefix__paint0_linear)"
      />
      <rect
        x={1.455}
        y={1.454}
        width={61.091}
        height={61.091}
        rx={22.788}
        stroke="#FDF3F3"
        strokeOpacity={0.06}
        strokeWidth={0.97}
      />
      <g filter="url(#prefix__filter0_d)">
        <rect
          x={15.915}
          y={16.201}
          width={11.539}
          height={31.732}
          rx={5.769}
          fill="url(#prefix__paint1_linear)"
        />
      </g>
      <path
        d="M48.017 45.689v-9.654a2.527 2.527 0 00-2.527-2.527H35.058c-1.488 0-2.672 1.292-2.33 2.74 1.922 8.12 8.54 11.293 13.113 11.672 1.25.103 2.176-.977 2.176-2.231z"
        fill="url(#prefix__paint2_linear)"
      />
      <circle
        cx={41.33}
        cy={22.864}
        r={6.664}
        fill="url(#prefix__paint3_linear)"
      />
      <rect
        x={1.255}
        y={1.255}
        width={61.49}
        height={61.49}
        rx={23.634}
        stroke="url(#prefix__paint4_linear)"
        strokeWidth={2.51}
      />
      <defs>
        <linearGradient
          id="prefix__paint0_linear"
          x1={32}
          y1={0.97}
          x2={32}
          y2={63.03}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#222527" />
          <stop offset={1} stopColor="#131415" />
        </linearGradient>
        <linearGradient
          id="prefix__paint1_linear"
          x1={19.367}
          y1={21.316}
          x2={25.432}
          y2={43.13}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EAECEB" />
          <stop offset={1} stopColor="#D9E9EE" />
        </linearGradient>
        <linearGradient
          id="prefix__paint2_linear"
          x1={40.151}
          y1={33.508}
          x2={40.151}
          y2={47.959}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CFF5F3" />
          <stop offset={1} stopColor="#BBF2EF" />
        </linearGradient>
        <linearGradient
          id="prefix__paint3_linear"
          x1={41.33}
          y1={16.2}
          x2={41.33}
          y2={29.527}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF8F76" />
          <stop offset={1} stopColor="#EB4A27" />
        </linearGradient>
        <linearGradient
          id="prefix__paint4_linear"
          x1={32}
          y1={0}
          x2={32}
          y2={64}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCFCF6" />
          <stop offset={1} stopColor="#8FA1DF" />
        </linearGradient>
        <filter
          id="prefix__filter0_d"
          x={15.515}
          y={15.961}
          width={12.34}
          height={32.533}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.16} />
          <feGaussianBlur stdDeviation={0.2} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export default Logo;
